import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import { toast } from "sonner";
import { ScanLine, Download, RefreshCw, Maximize2, X } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { qrUrl } from "@/lib/qr";
import { useConfirm } from "@/context/ConfirmContext";

function Settings({ b, max, reload }) {
  const [f, setF] = useState({ mode: b.mode, visits_enabled: b.visits_enabled, visit_points: b.visit_points });
  const save = async (extra = {}) => { try { await api.put("/qr/business", { ...f, ...extra }); toast.success("U ruajt"); reload(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className="bg-white rounded-2xl p-3 border border-slate-100 space-y-2" data-testid="bq-settings">
      <label className="text-[11px] text-slate-500 block">Lloji i QR-së në lokal
        <select data-testid="bq-mode" value={f.mode} onChange={(e) => setF({ ...f, mode: e.target.value })} className="w-full h-10 rounded-xl border border-slate-200 px-3 text-sm bg-white">
          <option value="both">Të dyja (e printuar + live)</option><option value="static">E printuar (kontrollohet GPS)</option><option value="live">Live në ekran (ndryshon vazhdimisht)</option>
        </select></label>
      <label className="flex items-center gap-2 text-xs text-slate-700"><input data-testid="bq-visits" type="checkbox" checked={f.visits_enabled} onChange={(e) => setF({ ...f, visits_enabled: e.target.checked })} className="accent-emerald-600" />Regjistro vizitat e klientëve</label>
      <label className="text-[11px] text-slate-500 block">Kredite për çdo vizitë (maks. {max})
        <input data-testid="bq-points" type="number" min="0" max={max} value={f.visit_points} onChange={(e) => setF({ ...f, visit_points: e.target.value })} className="w-full h-10 rounded-xl border border-slate-200 px-3 text-sm" /></label>
      <button data-testid="bq-save" onClick={() => save()} className="w-full h-10 rounded-xl bg-emerald-500 text-white text-sm font-bold">Ruaj</button>
    </div>
  );
}

export function BusinessQr({ b, max, reload }) {
  const nav = useNavigate();
  const { confirm } = useConfirm();
  const [full, setFull] = useState(false);
  const download = () => {
    const c = document.querySelector("[data-testid=bq-static] canvas");
    const a = document.createElement("a"); a.href = c.toDataURL("image/png"); a.download = "gjejshqip-qr-vizita.png"; a.click();
  };
  const regen = async () => {
    if (!(await confirm({ title: "QR e re e printuar", message: "QR-ja e vjetër e printuar nuk do të vlejë më. Vazhdo?", danger: true }))) return;
    await api.put("/qr/business", { mode: b.mode, visits_enabled: b.visits_enabled, visit_points: b.visit_points, regenerate: true }); reload();
  };
  return (
    <div className="space-y-3" data-testid="business-qr">
      <button data-testid="bq-scan-offer" onClick={() => nav("/skano")} className="w-full h-12 rounded-2xl bg-slate-900 text-white font-bold flex items-center justify-center gap-2"><ScanLine className="w-5 h-5" />Skano ofertën e klientit</button>
      {b.live && (
        <div className="bg-white rounded-2xl p-4 border-2 border-amber-300 text-center" data-testid="bq-live">
          <div className="text-sm font-bold text-slate-900">QR live për vizita</div>
          <QRCodeCanvas value={qrUrl(b.live)} size={200} className="mx-auto mt-2" />
          <p className="text-[11px] text-slate-500 mt-2">Mbaje këtë ekran hapur te banaku. Kodi ndryshon vetë, foto e vjetër nuk vlen.</p>
          <button data-testid="bq-full" onClick={() => setFull(true)} className="mt-2 h-9 px-3 rounded-full bg-amber-100 text-amber-800 text-xs font-bold inline-flex items-center gap-1"><Maximize2 className="w-4 h-4" />Ekran i plotë</button>
        </div>
      )}
      {b.static && (
        <div className="bg-white rounded-2xl p-4 border border-slate-100 text-center" data-testid="bq-static">
          <div className="text-sm font-bold text-slate-900">QR për printim (tavolinë, banak, hyrje)</div>
          <QRCodeCanvas value={qrUrl(b.static)} size={180} className="mx-auto mt-2" />
          <p className="text-[11px] text-slate-500 mt-2">Vizita pranohet vetëm kur klienti është fizikisht te lokali (GPS).</p>
          <div className="flex gap-2 mt-2 justify-center">
            <button data-testid="bq-download" onClick={download} className="h-9 px-3 rounded-full bg-emerald-50 text-emerald-700 text-xs font-bold inline-flex items-center gap-1"><Download className="w-4 h-4" />Shkarko</button>
            <button data-testid="bq-regen" onClick={regen} className="h-9 px-3 rounded-full bg-slate-100 text-slate-600 text-xs font-bold inline-flex items-center gap-1"><RefreshCw className="w-4 h-4" />QR e re</button>
          </div>
        </div>
      )}
      <Settings key={`${b.mode}${b.visit_points}${b.visits_enabled}`} b={b} max={max} reload={reload} />
      {full && b.live && (
        <div className="fixed inset-0 z-[80] bg-white flex flex-col items-center justify-center p-6" data-testid="bq-fullscreen">
          <button onClick={() => setFull(false)} className="absolute top-4 right-4 p-2" data-testid="bq-full-close"><X className="w-6 h-6" /></button>
          <div className="text-xl font-black text-slate-900 mb-4">Skano për vizitë</div>
          <QRCodeCanvas value={qrUrl(b.live)} size={300} />
          <p className="text-sm text-slate-500 mt-4">Hap gjejshqip.com → Skano QR</p>
        </div>
      )}
    </div>
  );
}
